// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--f407a";
export var footerLink = "Footer-module--footerLink--9a52f";
export var green = "Footer-module--green--b459f";
export var listLinks = "Footer-module--listLinks--a8ef8";
export var logos = "Footer-module--logos--8f254";
export var smallPrint = "Footer-module--smallPrint--fb27b";
export var socialNetwork = "Footer-module--socialNetwork--8c5e3";
export var socialNetworks = "Footer-module--socialNetworks--eb357";
export var wrapper = "Footer-module--wrapper--88fb3";